import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AccountPage from '../components/AccountPage';
import UserAccountForm from '../components/UserAccountForm';
import ParticipantDetailsForm from '../components/ParticipantDetailsForm';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  title: {
    marginTop: '2rem',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const SettingsPage = () => {
  const classes = useStyles();
  return (
    <AccountPage>
      <Divider />
      <Typography variant="h3" color="primary" gutterBottom className={classes.title}>Participant details</Typography>
      <Typography variant="body2" gutterBottom style={{width: '25rem'}}>These are the items related to the NDIS participant, whether it is yourself or someone you are acting on behalf of.</Typography>
      <Typography variant="body2" gutterBottom style={{width: '25rem'}}>We do not currently support the option to act on behalf of multiple participants from a single Clickability user account. If this is important to you please please let us know via our <Link to="/profile/feedback" className={classes.link}>feedback</Link> form.</Typography>
      <ParticipantDetailsForm />
      <Divider />
      <Typography variant="h3" color="primary" gutterBottom className={classes.title}>Account credentials</Typography>
      <Typography variant="body2" gutterBottom style={{width: '25rem'}}>These are items related to your specific user account.</Typography>
      <UserAccountForm />
    </AccountPage>
  );
};

export default SettingsPage;
